import {
  MetaplanListResponseDto,
  MetaplanItemResponseDto,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import {
  SubscriptionsEndpoints,
  GET_METAPLANS_URL,
  subscriptionsTags,
} from './settings';

export interface GetMetaplansParams {
  page?: number;
  limit?: number;
  q?: string;
}

export type { MetaplanItemResponseDto };

export const subscriptionsApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [subscriptionsTags.metaplansList],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [SubscriptionsEndpoints.getMetaplans]: builder.query<
        MetaplanListResponseDto,
        GetMetaplansParams | void
      >({
        query: (params) => ({
          method: 'GET',
          url: GET_METAPLANS_URL,
          params: params || {},
        }),
        providesTags: [subscriptionsTags.metaplansList],
      }),
    }),
  });

export const { useGetMetaplansQuery } = subscriptionsApi;
